import { render, staticRenderFns } from "./restriction-modal-edit.vue?vue&type=template&id=3437acd2"
import script from "./restriction-modal-edit.vue?vue&type=script&lang=js"
export * from "./restriction-modal-edit.vue?vue&type=script&lang=js"
import style0 from "./restriction-modal-edit.vue?vue&type=style&index=0&id=3437acd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports